module.exports = __webpack_public_path__ + "static/media/pw-white.036706e5.jpg";